import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ListItem\DeleteListItemController::deleteMethod
* @see app/Http/Controllers/ListItem/DeleteListItemController.php
* @route '/api/list-item/{list_item}'
*/
export const deleteMethod = (args: { list_item: string | number | { id: string | number } } | [list_item: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

deleteMethod.definition = {
    methods: ["delete"],
    url: '/api/list-item/{list_item}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\ListItem\DeleteListItemController::deleteMethod
* @see app/Http/Controllers/ListItem/DeleteListItemController.php
* @route '/api/list-item/{list_item}'
*/
deleteMethod.url = (args: { list_item: string | number | { id: string | number } } | [list_item: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { list_item: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { list_item: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            list_item: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        list_item: typeof args.list_item === 'object'
        ? args.list_item.id
        : args.list_item,
    }

    return deleteMethod.definition.url
            .replace('{list_item}', parsedArgs.list_item.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ListItem\DeleteListItemController::deleteMethod
* @see app/Http/Controllers/ListItem/DeleteListItemController.php
* @route '/api/list-item/{list_item}'
*/
deleteMethod.delete = (args: { list_item: string | number | { id: string | number } } | [list_item: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

const DeleteListItemController = { deleteMethod, delete: deleteMethod }

export default DeleteListItemController